/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Conf_MediumInputs */

const cs_addr_conf_medium = /** @type {(inputs: Addr_Conf_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Střední`)
};

const en_addr_conf_medium = /** @type {(inputs: Addr_Conf_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Addr_Conf_MediumInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_conf_medium = /** @type {((inputs?: Addr_Conf_MediumInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Conf_MediumInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_conf_medium(inputs)
	return cs_addr_conf_medium(inputs)
});